module.exports = __webpack_public_path__ + "dist/img/短信包.1ab02794.svg";